<div class="row" *ngFor="let candidate of candidateSummaries">
  <div class="col-md-3">
    <div class="candidate-list candidate-grid-2">
      <div class="candidate-list-image">
        <img class="img-fluid" [src]="candidate.photo ? candidate.photo : photoPath" alt="">
      </div>
      <div class="candidate-list-details-2">
        <div class="candidate-list-info">
          <div class="candidate-list-title-2">
            <a role="button" [routerLink]="" (click)="viewResume(candidate.resumeId)">View Profile & Reviews</a>
          </div>
          <div class="candidate-button">
            <a [routerLink]="" class="btn btn-success" role="button" (click)="selectCandidate(candidate.accountId)">Invite</a>
          </div>
          <ngb-rating [max]="5" [rate]="candidate.overallRating" [readonly]="true">
          </ngb-rating>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-6">
    <div class="candidate-list-details-2">
      <div class="candidate-list-info">
        <div class="candidate-list-title">
          <h5 class="mb-0">{{candidate.name}}</h5>
          <div class="candidate-list-option-2">
            <ul class="list-unstyled">
              <li>
                <i class="fas fa-map-marker-alt"></i>
                {{candidate.location}}
              </li>
              <li><i class="fas fa-filter"></i>{{lookupStore.getSector(candidate.sector)?.name}}</li>
              <li><i class="fas fa-briefcase"></i>{{candidate.experience}} years</li>
              <li><i class="fas fa-university"></i>{{lookupStore.getEducationLevel(candidate.educationLevel)?.value}}</li>
            </ul>
          </div>
        </div>
        <div class="candidate-list-head-2">
          <h5 class=mb-0> About Me</h5>
        </div>
        <div class="candidate-list-option">
          <ul class="list-unstyled">
            <li>
              <p>{{candidate.aboutMe}}</p>
            </li>
          </ul>
        </div>

      </div>
    </div>
  </div>
  <div class="col-md-3">
    <div class="candidate-list-favourite-time" *ngIf="showBookmark">
      <a class="candidate-list-favourite order-2" [ngClass]="{bookmarked: candidate.bookmarked === true}"
        title="Shortlist" [routerLink]="" (click)="onShortListClicked(candidate.profileId)"><i
          class="far fa-heart"></i></a>
    </div>
    <div class="candidate-list-favourite-time-2" *ngIf="showSalary">
      <ul class="list-unstyled">
        <li><i class="fas"></i>$ {{candidate.salary}}/{{getRateType(candidate.salaryType)}}</li>
      </ul>
    </div>
  </div>